import { ReactNode } from 'react'
import { LoadingErrorState } from '../loading-error-state'

interface PageLayoutProps {
  children: ReactNode
  className?: string
  isLoading?: boolean
  error?: unknown
  loadingMessage?: string
  errorMessage?: string
  /** @deprecated kept for backward compat; no longer rendered */
  headerProps?: Record<string, unknown>
}

export default function PageLayout({
  children,
  className = '',
  isLoading,
  error,
  loadingMessage,
  errorMessage,
}: PageLayoutProps) {
  return (
    <div className={`min-h-full bg-surface-page ${className}`}>
      <LoadingErrorState
        isLoading={isLoading}
        error={error}
        loadingMessage={loadingMessage}
        errorMessage={errorMessage}
      >
        {children}
      </LoadingErrorState>
    </div>
  )
}
